import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {AccountDialogService} from "../../services/account-dialogs-service.service";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";
import {AccountsFacadeService} from "../../angular/services/accounts-facade.service";
import {Subscription} from "rxjs";
import {AccountsService} from "../../services/accounts-service.service";
import {
  ConfigurationProfilesService
} from "../../../configuration-profiles/services/configuration-profiles-service.service";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class ShipperAccountCtrl implements IController {

  accountId: string;

  public account: AccountModel;
  public billingAccountLink: string = 'Go to billing account';
  public configurationProfile: any;
  public isFieldServiceEnabled: boolean;

  private openInfoSection: boolean;
  private openSmsSection: any;
  private selectAccountSubscription: Subscription;
  private canGetConfigurationProfile: boolean;

  constructor(private $log, private accountDialogService: AccountDialogService, private $mdSidenav,
              private accountsFacadeService: AccountsFacadeService,
              private IAMPermissions: IAMPermissionsService,
              private splitService: SplitService,
              private $timeout, private accountsService: AccountsService,
              private configurationProfilesService: ConfigurationProfilesService,
              private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private $state) {
    this.isFieldServiceEnabled = this.splitService.isFieldServiceEnabled();
  }

  $onInit() {
    this.accountsFacadeService.getOne(this.accountId);
    this.canGetConfigurationProfile = this.IAMPermissions.hasPermission('site.configuration.list');

    // Select Account
    this.selectAccountSubscription = this.accountsFacadeService.selectOne(this.accountId)
      .subscribe(account => {
        if (!!account) {
          this.account = angular.copy(account);

          if (!this.configurationProfile && this.account.configurationProfileId) {
            this._getConfigurationProfile(this.account.configurationProfileId);
          }

          // Update Angularjs Cycle
          this.$timeout(0).then(() => {
          });
        }
      });

    // Subscribe Account
    this.accountsFacadeService.subscribeToChannels();

    this.openInfoSection = false;
    this.openSmsSection = this.$state.current.name.match('sms');
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
  }

  $onDestroy() {
    this.selectAccountSubscription.unsubscribe();
    // this.accountsFacadeService.unsubscribeFromChannels();
    this.accountsFacadeService.clearStore();
  }

  openEdit($event) {
    this.accountDialogService.editShipperAccount($event, this.account);
  }

  onDeleteAvatar() {
    const accountCopy = angular.copy(this.account);
    accountCopy.avatarUrl = undefined;
    this.accountsService.updateOne(this.accountId, accountCopy)
      .then((account) => {
        this.account = angular.copy(account);
      });
  }

  toggleSidenav(event) {
    this.$mdSidenav('shipperAccountInfo').toggle();
  }


  collapseInfoSection($event) {
    $event.stopPropagation();
    this.openInfoSection = !this.openInfoSection;
  }


  onChangeArchiveStatus() {
    const accountCopy = angular.copy(this.account);
    accountCopy.isArchive = false;
    this.accountsService.unArchive(this.account.id)
      .then(() => {

      })
  }

  private _getConfigurationProfile(id: string) {
    if (!!this.canGetConfigurationProfile) {
      this.configurationProfilesService.getOne(id)
        .then((configurationProfile) => {
          this.configurationProfile = configurationProfile;
        })
    }
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccount', {
    bindings: {
      accountId: '<'
    },
    template: require('./shipper-account.html').default,
    controller: ShipperAccountCtrl
  });
